<template>
  <div class="c_embedded_image_gallery" :data-component-theme="theme">
    <div class="c_wrapper_2022">
      <h3 v-if="data.title" v-html="data.title"></h3>
      <ImageContentGridSlider v-if="data.grid" :data="data.grid" :lazy-load="true" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import ImageContentGridSlider from '../image_content_grid/ImageContentGridSlider.vue';

export default defineComponent({
  name: 'EmbeddedImageGallery',
  components: {
    ImageContentGridSlider,
  },
  props: {
    data: { type: Object, default: () => {} },
  },
  setup(props) {
    const theme = props.data.theme ?? 'darkMode';
    return { theme };
  },
});
</script>

<style lang="scss">
.c_embedded_image_gallery {
  --embedded-image-gallery-bg: var(--color-black);
  --embedded-image-gallery-color: var(--color-white);
  --embedded-image-gallery-link-color: var(--color-yellow);
  padding: px_to_rem(40) 0;
  @include mq($mq_sm_to_md) {
    padding: px_to_rem(80) 0;
  }
  &[data-component-theme='darkMode'] {
    --embedded-image-gallery-bg: var(--color-black);
    --embedded-image-gallery-color: var(--color-white);
    --embedded-image-gallery-link-color: var(--color-yellow);
  }
  &[data-component-theme='lightMode'] {
    --embedded-image-gallery-bg: var(--color-white);
    --embedded-image-gallery-color: var(--color-black);
    --embedded-image-gallery-link-color: var(--color-red);
  }
  background-color: var(--embedded-image-gallery-bg);
  color: var(--embedded-image-gallery-color);
  h3 {
    @include fs_lh(32, 40, 32, 40);
    @include font('graphik_semibold');
    text-align: left;
    border-bottom: 3px solid var(--color-yellow);
    padding-bottom: px_to_rem(12);
    margin-bottom: px_to_rem(32);
    @include mq($mq_sm_to_md) {
      margin-bottom: px_to_rem(60);
    }
  }
  figcaption,
  .c_image_grid_slider__slider_controls {
    color: var(--embedded-image-gallery-color);
  }
  a,
  a:visited,
  a:focus {
    color: var(--embedded-image-gallery-link-color);
  }
  .c_image_grid_slider__top,
  .c_image_grid_slider__bottom {
    height: auto;
  }
}
</style>
